// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"af40cfd9","292":"4d1ecb97","447":"403702d0","615":"b0dccf74","712":"1e1ba409","753":"890dcc77","767":"f3e0e8e7"}[chunkId] + ".chunk.js";
};